
import { Component, OnInit, ChangeDetectorRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrderService } from '@app/shared/services/order.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.css']
})
export class OrderListComponent implements OnInit {
  orderList: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 15;
  searchText: string = '';
  selectedOrder: any;
  showConfirmationForm: boolean = false;
  confirmationCode: string = '';
  comments: string = '';
  confirmedOrder: any;
  confirmationForm: FormGroup;
  orderId: string;
  isConfirming: boolean = false;

  constructor( private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private orderService: OrderService,
    private activatedRoute: ActivatedRoute,
    private router: Router,

  ) {
    this.confirmationForm = this.formBuilder.group({
      department: [''],
      sign: [''],
    });
  }

 editOrderForm = this.formBuilder.group({
    ticketno: [{ value: '', disabled: true }, [Validators.required]],
    clientName: [{ value: '', disabled: true }, [Validators.required]],
    refNo: [{ value: '', disabled: true }, [Validators.required]],
    poNo: ['', [Validators.required]],
    jobName: ['', [Validators.required]],
    jobType: ['', [Validators.required]],
    orderKgs: ['', [Validators.required]],
    ddDate: ['', [Validators.required]],
    gram: [''],
    orderPcs: [''],
    fdOption: ['', [Validators.required]],
    packageType: ['', [Validators.required]],
    sMat: ['', [Validators.required]],
      thickness: ['', [Validators.required]],
      width: ['', [Validators.required]],
      material1: this.formBuilder.group({
        sMat2: [''],
      thickness2: [''],
      width2: [''],
    }),
    material2: this.formBuilder.group({
      sMat3: [''],
      thickness3: [''],
      width3: [''],
  }),
      coilWidth: ['', [Validators.required]],
      coilod: ['', [Validators.required]],
    poDate: ['', [Validators.required]],
   
    sRemrk: ['', [Validators.required]],
    barcode: ['', [Validators.required]],
    dispatch: ['', [Validators.required]],
    remark: ['', [Validators.required]],
    prepare: ['', [Validators.required]],
    approved: ['', [Validators.required]],
  })

  ngOnInit(): void {

    console.log('URL Params:', this.activatedRoute.snapshot.params);
    this.getAllOrder();

    this.activatedRoute.params.subscribe((params) => {
      console.log('Route Params:', params);
      const orderId = params['id'];
      if (orderId) {
        this.orderId = orderId;
        this.updateOrder(this.orderId);
        this.showTable = false;
      } else {
        // console.error('OrderId is undefined or null in route parameters.');
      }
    });
  }
  resetmaterial1(): void {
    const material1= this.editOrderForm.get('material1') as FormGroup;
    material1.get('sMat2')?.setValue('');
    material1.get('thickness2')?.setValue('');
    material1.get('width2')?.setValue('');
}
resetmaterial2(): void {
  const material2= this.editOrderForm.get('material2') as FormGroup;
  material2.get('sMat3')?.setValue('');
  material2.get('thickness3')?.setValue('');
  material2.get('width3')?.setValue('');
}
  // this.cdr.detectChanges(); // Trigger change detection

  getAllOrder() {
    this.orderService.getOrder().subscribe(
      (res: any) => {
        // Filter out the confirmed orders from the orderList
        this.orderList = res.filter((order: { status: string; }) => order.status == 'Pending');
        console.log(this.orderList);
        this.orderList.reverse();
        this.cdr.detectChanges();
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  // getAllOrder() {
  //   this.orderService.getOrder().subscribe(
  //     (res: any) => {
  //       // Ensure the result is an array
  //       if (Array.isArray(res)) {
  //         this.orderList = res.filter((order: { status: string; }) => order.status === 'Pending');
  //         console.log(this.orderList);
  //         this.orderList.reverse();
  //       } else {
  //         console.error('Expected an array from the service, but received:', res);
  //         this.orderList = []; // Fallback to an empty array
  //       }
  //       this.cdr.detectChanges();
  //     },
  //     (err: any) => {
  //       console.error('Error fetching orders:', err);
  //       this.orderList = []; // Ensure orderList is an empty array in case of an error
  //     }
  //   );
  // }
  
  updateOrder(id: any) {
    this.orderService.getOrderById(id).subscribe(
      (res: any) => {
        // Enable all controls if needed
        this.editOrderForm.get('ticketno')?.enable();
        this.editOrderForm.get('clientName')?.enable();
        this.editOrderForm.get('refNo')?.enable();
        // Then patch the value
        this.editOrderForm.patchValue(res);
         // Now patch material1 and material2 arrays/objects
      if (res.material1 && res.material1.length > 0) {
        this.editOrderForm.patchValue({
          material1: {
            sMat2: res.material1[0]?.sMat2 || '',
            thickness2: res.material1[0]?.thickness2 || '',
            width2: res.material1[0]?.width2 || ''
          }
        });
      }

      if (res.material2 && res.material2.length > 0) {
        this.editOrderForm.patchValue({
          material2: {
            sMat3: res.material2[0]?.sMat3 || '',
            thickness3: res.material2[0]?.thickness3 || '',
            width3: res.material2[0]?.width3 || ''
          }
        });
      }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  submitForm() {
    if (this.editOrderForm.valid) { // Check if the form is valid
      const formData = this.editOrderForm.value; // Get the form values
      console.log('Form Values:', formData);
  
      // Call the updateOrder method from your orderService
      this.orderService.updateOrder(this.orderId, formData).subscribe(
        (response: any) => {
          // Assuming the response contains the updated order data or relevant information
          console.log('Order updated successfully:', response);
  
          // Redirect to the order list router after successful submission
          this.router.navigate(['/orderList']);
        },
        (err: any) => {
          console.error('Error updating order:', err);
          // Handle the error in the UI or take appropriate action
          // Example: You might want to show a notification or alert
        }
      );
    } else {
      console.log('Form is invalid');
      // Optionally: You can display a message to the user about the invalid form
    }
  }
  
  

  openConfirmationForm(order: any): void {
    // Check if the order is not already confirmed
    if (order.status !== 'Confirmed') {
      this.selectedOrder = order;
      this.showConfirmationForm = true;
    } else {
      // Handle the case when the order is already confirmed (e.g., show a message)
      console.log('This order is already confirmed or in the process of confirmation.');
    }
  }




  handleConfirmation() {
  if (!this.isConfirming) {
    this.isConfirming = true; // Set the flag to indicate form submission is in progress

    const confirmationData = {
      department: this.confirmationForm.get('department').value,
      signature: this.confirmationForm.get('sign').value,
    };

    // Close the confirmation form immediately
    this.showConfirmationForm = false;

    // Remove the confirmed order from the orderList immediately
    this.orderList = this.orderList.filter(order => order._id !== this.selectedOrder._id);

    this.orderService.confirmOrder(this.selectedOrder._id, confirmationData).subscribe(
      (updatedOrder: any) => {
        // Reset the form
        this.confirmationForm.reset();
      },
      (error) => {
        console.error(error);
        // If there's an error, you might want to re-add the order to the orderList
        this.orderList.push(this.selectedOrder);
      },
      () => {
        // Reset the flag after the request completes (whether success or error)
        this.isConfirming = false;
      }
    );
  }
}

  
  

  
  onCancel(): void {
    // Handle cancel button click, if needed.
     this.showConfirmationForm = false;
  }

  showTable = true;
  formData: any = {};

  toggleView() {
    this.showTable = !this.showTable;
    this.formData = {};
  }


  saveOrder() {
    this.showTable = false;
    this.formData = {};
  }

  // submitForm(): void {
  //   if (this.editOrderForm.valid) {
  //       const formData = {};
  //       Object.keys(this.editOrderForm.controls).forEach((key) => {
  //           formData[key] = this.editOrderForm.get(key)?.value;
  //       });

  //       this.orderService.updateOrder(this.orderId, formData).subscribe(
  //           (response: any) => {
  //               // Assuming the response contains the updated order data or relevant information
  //               console.log('Order updated successfully:', response);

  //               // Redirect to the order list router after successful submission
  //               this.router.navigate(['/orderList']);
  //           },
  //           (err: any) => {
  //               console.error(err);
  //               // Handle the error in the UI or take appropriate action

  //               // Example: Redirect to an error page
  //               // this.router.navigate(['/error']);
  //           }
  //       );
  //         }
  //     }
  

  get paginatedClients(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.orderList
      .filter((client) => this.matchesSearch(client))
      .slice(startIndex, endIndex);
  }
  getNumberRange(end: number): number[] {
    return Array.from({ length: end }, (_, index) => index + 1);
  }
  
  ceil(value: number): number {
    return Math.ceil(value);
  }
  

  get totalItems(): number {
    return this.orderList.filter((client) => this.matchesSearch(client)).length;
  }

  calculateRangeStart(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  calculateRangeEnd(): number {
    return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  onSearch(): void {
    this.currentPage = 1; // Reset to the first page when performing a new search
  }

  private matchesSearch(client: any): boolean {
    const searchFields = ['clientName', 'email', 'contactNo'];
    const lowerCaseSearch = this.searchText.toLowerCase();

    return searchFields.some((field) => {
      const fieldValue = client[field];
      if (fieldValue && typeof fieldValue === 'string') {
        return fieldValue.toLowerCase().includes(lowerCaseSearch);
      }
      return false;
    });
  }

  showPcsGram: boolean = false;
  totalPcs: number = 0;
  calculateTotalPcs() {
    const orderPcs = +this.editOrderForm.get('orderPcs')?.value;
    this.totalPcs=orderPcs;

  }
  togglePcsGram() {
    this.showPcsGram = !this.showPcsGram;
   this.calculateTotalPcs();
  }
  calculateOrderKgs() {
    const pcsGram = parseFloat(this.editOrderForm.get('gram')?.value) || 0;
    if (pcsGram !== 0) {
      const calculatedKgs = this.totalPcs / pcsGram;
      console.log(calculatedKgs);
      this.editOrderForm.get('orderKgs')?.setValue(calculatedKgs.toFixed(2)); // Set value in orderKgs input field
    }
  }

  deleteSelectedEntries() {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    const selectedIds = [];
    
    checkboxes.forEach((checkbox) => {
      if ((checkbox as HTMLInputElement).checked) {
        selectedIds.push((checkbox as HTMLInputElement).dataset.id); // Assuming dataset.id is used for ID
      }
    });

    if (selectedIds.length > 0) {
      this.orderService.deleteAllOrder(selectedIds).subscribe(
        (response) => {
          console.log('Entries deleted successfully:', response);
          // Optionally update your client list after deletion
          this.getAllOrder(); // Example method to fetch clients again
        },
        (error) => {
          console.error('Error deleting entries:', error);
          // Handle error in UI or show error message
        }
      );
    } else {
      console.log('No entries selected for deletion');
      // Handle case where no entries are selected
    }
  }

  selectAllChanged(event: Event) {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    checkboxes.forEach((checkbox) => {
      (checkbox as HTMLInputElement).checked = (event.target as HTMLInputElement).checked;
    });
  }


}
